<template>
  <v-dialog :value="show" persistent max-width="420">
    <v-card>
      <v-card-title class="headline">正在匯出 Excel</v-card-title>
      <v-card-text>
        <template v-if="error">
          <p class="error--text mb-0">{{ error }}</p>
        </template>
        <template v-else>
          <p class="mb-2">{{ phaseLabel }}</p>
          <v-progress-linear
            :value="displayPercent"
            :indeterminate="isIndeterminate"
            height="8"
            color="primary"
          ></v-progress-linear>
          <p v-if="total > 0" class="mt-3 mb-0 text--secondary">
            已處理 {{ current | number }} / {{ total | number }} 筆
          </p>
        </template>
      </v-card-text>
      <v-card-actions v-if="error">
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="$emit('close')">關閉</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    show: { type: Boolean, default: false },
    phase: { type: String, default: 'building' },
    current: { type: Number, default: 0 },
    total: { type: Number, default: 0 },
    error: { type: String, default: null },
  },
  computed: {
    phaseLabel() {
      if (this.phase === 'building') return '整理資料中…'
      if (this.phase === 'writing') return '產生檔案中…'
      if (this.phase === 'downloading') return '下載中…'
      return '處理中…'
    },
    displayPercent() {
      if (this.total <= 0) return 0
      if (this.phase === 'writing') return 100
      return Math.round((this.current / this.total) * 100)
    },
    isIndeterminate() {
      return this.phase === 'writing'
    },
  },
  filters: {
    number(value) {
      return Number(value || 0).toLocaleString()
    },
  },
}
</script>
